import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"
import Toasted from "vue-toasted"
import EodyLoader from "./_helper/EodyLoader"
import { apiURL } from "./_helper/http-constants"
import VueSweetalert2 from "vue-sweetalert2"
import "sweetalert2/dist/sweetalert2.min.css"
import { formatDistanceToNow, format } from "date-fns"

// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap/dist/js/bootstrap.min.js"
import "@/assets/css/main.css"
import "@/assets/css/blog.css"
import "@/assets/css/account.scss"
import "@/assets/fonts/icomoon/style.css"
import "@/assets/css/custom.css"
import _ from "lodash"
// import "vue-good-table/src/styles/style.scss"
import "vue-good-table/dist/vue-good-table.css"

Vue.config.productionTip = false
Vue.config.silent = true

// if (!window.location.href.includes("https")) {
//     window.location.href = window.location.href.replace("http", "https")
// }

const toastedOptions = {
    duration: 3000,
}
Vue.use(Toasted, toastedOptions)
Vue.use(VueSweetalert2)
Vue.component("v-select", vSelect)
Vue.component("eody-loader", EodyLoader)
Object.defineProperty(Vue.prototype, "_", { value: _ })

Vue.filter("course_image", function(file) {
    if (file) {
        return apiURL + "/books/" + file
    }
    return file
})

Vue.filter("receivers_name", function(receivers) {
    var name = ""
    if (receivers.length) {
        name = receivers[0].firstName + "-" + receivers[0].lastName
        if (typeof receivers[1] != "undefined") {
            name = name + ",..."
        }
    }
    return name
})

var remove_tage = function(text, length, clamp) {
    clamp = clamp || "..."
    var node = document.createElement("div")
    node.innerHTML = text
    var content = node.textContent
    return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter("truncate", remove_tage)

var date_moment = function(date) {
    return format(new Date(date), "MMM d")
}

Vue.filter("date_formate", date_moment)

var date_file_share = function(date) {
    return format(new Date(date), "do MMM, yyyy | h.mm a")
}

Vue.filter("date_formate_file_share", date_file_share)

var today_yesterday = function(myDate) {
    return formatDistanceToNow(new Date(myDate), { addSuffix: true })
}

Vue.filter("today_yesterday", today_yesterday)

// import VueSessionStorage from "vue-sessionstorage"
// Vue.use(VueSessionStorage)

Vue.mixin({
    data() {
        var user = JSON.parse(window.localStorage.getItem("user"))
        return {
            loginHeader: false,
            loginFooter: false,
            user: user,
            isLoggedIn: window.localStorage.getItem("isLogged"),
            firstName: user ? user.firstName : "",
            lastName: user ? user.lastName : "",
        }
    },
    methods: {
        logout: function() {
            window.localStorage.removeItem("isLogged")
            window.localStorage.removeItem("user")
            this.isLoggedIn = false
            this.loginHeader = false
            this.loginFooter = false
            this.$router.push({ name: "login" })
        },
    },
})
new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app")
